import { useEffect, useMemo } from 'react';

import { FileDescriptor } from '@dreryk/command-query-ws-api';

import { StyledHealthcareInstitutionLogo } from './HealthcareInstitutionLogo.styled';
import { StyledHealthcareInstitutionLogoImage } from './HealthcareInstitutionLogoImage.styled';

type HealthcareInstitutionLogoBasicProps = {
   readonly fileDescriptor: FileDescriptor;
};

export const HealthcareInstitutionLogoBasic = (props: HealthcareInstitutionLogoBasicProps): JSX.Element => {
   const url = useMemo<string>(() => {
      return URL.createObjectURL(props.fileDescriptor.file!);
   }, [props.fileDescriptor]);

   useEffect(() => {
      return () => URL.revokeObjectURL(url);
   }, [url]);

   return (
      <StyledHealthcareInstitutionLogo justifyContent={'center'} alignItems={'center'}>
         <StyledHealthcareInstitutionLogoImage src={url} />
      </StyledHealthcareInstitutionLogo>
   );
};
